export const TOKEN_WORD = "WORD";
export const TOKEN_INT = "INT";
export const TOKEN_FLOAT = "FLOAT";
export const TOKEN_SPACE = "SPACE";
export const TOKEN_COMMA = "COMMA";
export const TOKEN_DOT = "DOT";
export const TOKEN_BRACKET_BEGIN = "BRACKET_BEGIN";
export const TOKEN_BRACKET_END = "BRACKET_END";
export const TOKEN_SINGLE_QUOTE = "'";
export const TOKEN_DOUBLE_QUOTE = '"';
export const TOKEN_NEW_LINE = "NEW_LINE";
export const TOKEN_UNKNOWN = "UNKNOWN";

const reList: Array<[TokenType, RegExp]> = [
    [TOKEN_WORD, RegExp(/^[-'a-zA-Z]+/)],
    [TOKEN_FLOAT, RegExp(/^[0-9]+\.[0-9]+/)],
    [TOKEN_INT, RegExp(/^[0-9]+/)],
    [TOKEN_SPACE, RegExp(/^ /)],
    [TOKEN_DOT, RegExp(/^\./)],
    [TOKEN_COMMA, RegExp(/^,/)],
    [TOKEN_BRACKET_BEGIN, RegExp(/^\(/)],
    [TOKEN_BRACKET_END, RegExp(/^\)/)],
    [TOKEN_SINGLE_QUOTE, RegExp(/'/)],
    [TOKEN_DOUBLE_QUOTE, RegExp(/"/)],
    [TOKEN_NEW_LINE, RegExp(/\n/)],
    [TOKEN_UNKNOWN, RegExp(/./)],
];

export type TokenType =
    | "WORD"
    | "INT"
    | "FLOAT"
    | "SPACE"
    | "COMMA"
    | "DOT"
    | "BRACKET_BEGIN"
    | "BRACKET_END"
    | "'"
    | '"'
    | "NEW_LINE"
    | "UNKNOWN";

export function findTokens(
    text: string,
    list: Array<{
        type: TokenType;
        value: string;
    }>
) {
    for (let i = 0; i < reList.length; i += 1) {
        const [type, re] = reList[i];
        const found = text.match(re);
        if (found) {
            list.push({ type, value: found[0] });
            findTokens(text.substr(found[0].length), list);
        }
    }

    return list;
}
